import { feature } from 'topojson'
import { useEffect, useState } from 'react'
// import parksTopojson from '../data/FilteredSimplifiedParkBoundaries.topo.json'

const parksTopojson = `${process.env.PUBLIC_URL}/maps/FilteredSimplifiedParkBoundaries.topo.json`
export default function useParksGeojson() {
  const [geojson, setGeojson] = useState(null)
  useEffect(() => {
    const fetchGeojson = async () => {
      const response = await fetch(parksTopojson)
      const topojson  = await response.json()
      const geojson = feature(topojson, topojson.objects.parks)
      setGeojson(geojson)
    }
    fetchGeojson()
  }, [])
  return geojson
}
